import { getLastBuyRent, getLastPropertyKind } from "./userPreferences";

/**
 * Home path matching saved buy/rent + property kind (navbar / onboarding).
 * @returns {string} pathname without query
 */
export function getHomePathForSavedPreferences() {
  const buyRent = getLastBuyRent() || "buy";
  const kind = getLastPropertyKind() || "apartment";
  if (buyRent === "rent") {
    if (kind === "villa") return "/rent-villas-home";
    return "/rent-apartments-home";
  }
  if (kind === "villa") return "/villas-home";
  if (kind === "plot") return "/plots-home";
  return "/apts-home";
}

/** Buy landing hubs: redirect to saved buy/rent + property kind after first city pick. */
const BUY_HOME_LIKE = new Set(["/", "/apts-home", "/villas-home", "/plots-home"]);

function normalizePath(p) {
  if (!p || p === "/") return "/";
  return p.endsWith("/") && p.length > 1 ? p.slice(0, -1) : p;
}

/**
 * After onboarding: send users to their preferred home with ?city=, or preserve deep links with ?city= merged in.
 * @param {string} pathname - current location.pathname
 * @param {string} search - current location.search (may include ?)
 * @param {string} citySlug
 * @returns {string} full path + query for navigate()
 */
export function getPathAfterCityOnboarding(pathname, search, citySlug) {
  const slug = String(citySlug || "").trim().toLowerCase();
  const path = normalizePath(pathname || "/");
  const qsCity = `city=${encodeURIComponent(slug)}`;

  if (path === "/rent-apartments-home" || path === "/rent-villas-home") {
    return `${path}?${qsCity}`;
  }
  if (path === "/rents-home") {
    return `/rent-apartments-home?${qsCity}`;
  }

  if (BUY_HOME_LIKE.has(path)) {
    const home = getHomePathForSavedPreferences();
    return `${home}?${qsCity}`;
  }

  const params = new URLSearchParams(search?.replace(/^\?/, "") || "");
  params.set("city", slug);
  const q = params.toString();
  return `${pathname}${q ? `?${q}` : `?${qsCity}`}`;
}
